import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-preference-toggle',
  template: `
    <div class="PreferenceToggle">
      <fl-toggle
        class="mr-xxsmall"
        label="{{ label }}"
        [flTrackingLabel]="trackingLabel"
        [control]="control"
        (click)="$event.stopPropagation()"
      >
      </fl-toggle>
      <p class="font-bold">{{ description }}</p>
    </div>
  `,
  styleUrls: ['./preference-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreferenceToggleComponent {
  @Input() control: FormControl<boolean>;
  @Input() trackingLabel: string;
  @Input() description: string;
  @Input() label: string;
}
